<template>
  <b-modal centered v-model="showModalMessages" ref="messages-history">
    <div class="modal-header d-flex align-items-center justify-content-between">
      <h3 class="mr-2"><i class="fa fa-comments"></i> Mensagem</h3>
      <button v-if="btnRelatorio" class="btn-report" @click="onExportExcel">
        <i class="fa fa-file-alt"></i>
      </button>
    </div>
    <div class="modal-content">
      <ChatMessages
        v-show="showModalMessages"
        ref="chatMessages"
        :messages="messages"
        :identifierProvider="identifierProvider"
        :provider="provider"
        :buttonReply="false"
      />
    </div>
    <template #modal-footer>
      <div class="w-100 text-right">
        <button type="button" class="btn btn-third btn-sm" v-on:click="showModalMessages = false" v-b-tooltip.hover :title="'OK'">
          <i class="fa "></i><span class="d-md-down-none">Ok</span>
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import ChatMessages from '@/views/private/atendimento/components/chat/ChatMessages.vue'
import AtendimentoRepository from '@/shared/http/repositories/atendimento/atendimento'
import ReportAtendimentoRepository from '@/shared/http/repositories/crm/reportAtendimento.js'

export default {
  name: 'MessagesModal',
  components: {
    ChatMessages
  },
  data () {
    return {
      showModalMessages: false,
      messages: [],
      conversation: null,
      provider: null,
      identifierProvider: null
    }
  },
  props: {
    btnRelatorio: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    async openModal (conversationId, provider, identifierProvider) {
      try {
        this.provider = provider
        this.identifierProvider = identifierProvider
        this.conversation = conversationId
        const response = await AtendimentoRepository.GetConversationMessages(conversationId)
        const { data } = response
        let messages = []

        if (data && data.length > 0) {
          messages = data.map((message, index) => ({
            ...message,
            sent: true,
            order: index
          }))
        }
        this.messages = messages
        this.showModalMessages = true
      } catch (error) {
        console.error(error)
      }
    },
    closeModal () {
      this.showModalMessages = false
    },
    onExportExcel () {
      var obj = {conversationId: this.conversation}
      ReportAtendimentoRepository.ExportAllMessages(obj)
        .then((response) => {
          const fileStartName = this.moment().format('YYYYMMDDhhmm')
          const blob = new Blob([this.base64ToArrayBuffer(response.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const url = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileStartName + 'RelatorioMensagens.xlsx'
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
        })
        .catch(this.onException)
    },
    base64ToArrayBuffer (base64) {
      let binaryString = window.atob(base64)
      var len = binaryString.length
      var bytes = new Uint8Array(len)
      for (var i = 0; i < len; i++) {
        bytes[i] = binaryString.charCodeAt(i)
      }
      return bytes.buffer
    }
  }
}
</script>

<style scoped>
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
}

.btn-report {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 2.0em;
  color: #ffffff;
}

.btn-report:hover {
  color: #d5d4d4;
}

.modal-content {
  height: 400px;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/private/atendimento/components/modal/MessageModals.vue